/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component } from "react";
import { isUndefined } from "utils/lodashUtils";
import AccessibilityCss from "./Accessibility.css";
import { getAccessibleComponentToRender } from "./AccessibilityComponentHelper";
import { overlayEvents } from "overlays/OverlayEvents";
import { FORM_ACCESSIBILITY_NODES_PREFIX } from "constants/constants";

class AccessiblePageContent extends Component {
  constructor() {
    super();
    this.attachAccContent = this.attachAccContent.bind(this);
  }

  componentDidMount() {
    if (this.props.pageAccText && this.props.enableFormsAccessiblity) {
      this.triggerAccLoadedEvent();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pageAccText !== this.props.pageAccText && this.props.enableFormsAccessiblity) {
      this.triggerAccLoadedEvent();
    }
  }

  triggerAccLoadedEvent() {
    overlayEvents.trigger("accLayerLoaded", {
      pageIndex: this.props.pageIndex,
      prefix: FORM_ACCESSIBILITY_NODES_PREFIX
    });
  }

  attachAccContent(elementHandle) {
    if (elementHandle) {
      this.props.setAcessiblePageContentHandle(elementHandle);
    }
  }

  getAccessibleDOMContent(pageAccText, zoomLevel, pageIndex) {
    return pageAccText.map(({ node }, index) => getAccessibleComponentToRender(node, zoomLevel, index, pageIndex));
  }

  render() {
    const {
      pageAccText,
      loadPageAccText,
      shouldFetchAccContent,
      height,
      width,
      pageIndex,
      language,
      zoomLevel
    } = this.props;
    if (shouldFetchAccContent) {
      if (isUndefined(pageAccText)) {
        loadPageAccText();
        return (
          <div
            style={{ height, width }}
            className={AccessibilityCss.pageSizeContainer}
            aria-label={`Loading Page ${pageIndex + 1}`}
          >
            {/* <p className={ AccessibilityCss.elementInvisible } role="status">Loading page { pageIndex + 1 } content.</p> */}
          </div>
        );
      }
      const accessibleDomContent = this.getAccessibleDOMContent(pageAccText, zoomLevel, pageIndex);

      return (
        <div
          lang={language.toLowerCase()}
          ref={this.attachAccContent}
          style={{ height, width }}
          className={AccessibilityCss.pageSizeContainer}
        >
          <div style={{ height, width }} className={AccessibilityCss.pageIndexContainer}>
            {`Page ${pageIndex + 1}`}
          </div>
          {accessibleDomContent}
        </div>
      );
    }
    return null;
  }
}

AccessiblePageContent.defaultProps = {
  onLinkClick: () => {},
  language: ""
};

export { AccessiblePageContent };
